import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import _get from 'lodash.get';

const withStoryPriceTag = WrappedComponent => {
  const PriceTagHOC = props => {
    const { userData, priceTags } = props;
    const [prcValue, setPrcValue] = useState(0);
    const [paidStoriesMsid, setpaidStoriesMsid] = useState([]);

    useEffect(
      () => {
        const paidStories = sessionStorage.getItem('paidstories');
        if (paidStories) {
          setpaidStoriesMsid(paidStories?.split(','));
        }
        if (Object.keys(userData).length > 0) {
          setPrcValue(userData?.prcValue);
        }
      },
      [userData],
    );

    const prcLabel = `prc${prcValue}`;
    const priceTag = priceTags && priceTags[prcLabel];

    return (
      <WrappedComponent
        {...props}
        paidStoriesMsid={paidStoriesMsid}
        priceTag={priceTag}
        prcValue={prcValue}
      />
    );
  };

  const mapStateToProps = state => ({
    priceTags: _get(state.translationConfig?.nudges, 'PPSPriceWidget', null),
    userData: _get(state, 'login.userData', {}),
  });

  return connect(mapStateToProps)(PriceTagHOC);
};

export default withStoryPriceTag;
